class ClinicSettings {
    public Id: string;
    public Tag: string;
    public Comment: string;
    public EnablePortalNotification: boolean;
    public EnablePreventiveCareDashboard: boolean;
    public EnableFollowUps: boolean;
    public EnablePortfolioPortalSyncHistory: boolean;
    public EnablePatientEdit: boolean;
    public EnablePatientEditEmail: boolean;
    public EnableMotherNameMandatoryPatientCreation: boolean;
    public EnableNameFamilyDDNMandatoryPatientCreation: boolean;
    public EnableExternalPatientSearch: boolean;
    public EnableExternalCommunication: boolean;
    public EnableTelemedFeature: boolean;
    public EnableCnesst: boolean;
    public EnableFormFaxing: boolean;
    public EnableTelemedPictureInPicture: boolean;
    public EnableIsTeleconsultationCheckbox: boolean;
    public EnableXComPatientImport: boolean;
    public PatientAgeOfConsent: number;
    public EnableCanCreatePatientPermission: boolean;
    public EnableQuebecVaccinationRegistry: boolean;
    public EnableCovidQuestionnaire: boolean;
    public Enable24hSchedule: boolean;
    public EnablePharmaNet: boolean;
    public EnableHealthCardValidation: boolean;
    public EnableMyleRTC: boolean;
    public EnableQuebecObstetricalFile: boolean;
    public DefaultExternalBillingProvider: string;
    public EnableWorkSafeBcFormFeature: boolean;
    public EnableOntarioObstetricalFile: boolean;
    public EnableNewFmpBillingIntegration: boolean;
    public EnableOntarioPatientEnrollment: boolean;
    public EnableBonjourSantePatientUpdatePassthrough: boolean;
    public EnablePatientUpdatePassthrough: boolean;
    public EnableBcCareConnect: boolean;
    public EnableBritishColumbiaObstetricalFile: boolean;
    public EnableBSLSeeAllLabsForRegisteredPatients: boolean;
    public EnableWalkMe: boolean;
    public EnableEnrolledPatientResultFilter: boolean;
    public EnableSignedAuthorization: boolean;
    public EnableMedfarDictionaryLabSearchInsteadOfDoctorSearchForBcClients: boolean;
    public EnableInboundFaxTriage: boolean;
    public EnableSendFax: boolean;
    public EnableMedicalServicesPlanEligibility: boolean;
    public EnableRamqGL6Service: boolean;
    public EnableConsultationExamRequestAttachments: boolean;
    public EnableSitePortalInformation: boolean;
    public EnableSecondScreen: boolean;
    public EnablePopulationBasedFunding: boolean;
    public EnableRelations: boolean;
    public EnableExternalCommunicationV2: boolean;
    public EnableFaxRetries: boolean;
    public EnablePrivateBillRecipient: boolean;
    public EnableAvailabilityRules: boolean;
    public BookingWindowEndOfDayAdjustment: string;
    public EnableConsentProgramHistory: boolean;
    public EnableCanadianTriageAndAcuityScore: boolean;
    public EnableRealTimeNotifications: boolean;
    public EnablePrescriptionRenewal: boolean;
    public EnableExportTimeSlots: boolean;
    public EnableDocumentInAppView: boolean;
    public EnableResultsFixes: boolean;
    public EnableArmeniaCountryAndStates: boolean;
    public EnableAutoLinkAppointmentToNote: boolean;
    public EnableBookingAlgorithmSiteAndOrganizationTargetOptions: boolean;
    public EnablePatientBillingHistory: boolean;
    public EnableContactDirectory: boolean;
    public EnableBillingReconciliationReport: boolean;
    public EnableLongTermMedication: boolean;
    public RequireAppointmentLinkToSignNote: boolean;
    public RequireOasisClassToSignNote: boolean;
    public RequirePatientExternalIdToSignNote: boolean;
    public IsCalendarReadOnly: boolean;
    public EnableNotificationConfiguration: boolean;
    public EnableCRDSRecentPurge: boolean;
    public EnableDirectPatientProfileEdits: boolean;
    public EnableDiagnosisOnPatientNoteTile: boolean;
    public EnableExternalBillingEmployeeSelectPopup: boolean;
    public EnableGroupAppointmentAndNote: boolean;
    public EnableCalendarAppointmentsCountsCaching: boolean;
    public EnableFaxAccountNumberDescription: boolean;
    public EnableQuickDocumentSigning: boolean;
    public EnablePdfAdditionalInfo: boolean;
    public EnableDynamicRosterCalendarSorting: boolean;
    public EnableDateOfBirthPortalActivation: boolean;
    public EnableVigilanceWebApi: boolean;
    public EnableConsultationRequestWorkflowImprovements: boolean;
    public EnablePortalInvitationFlowV2: boolean;
    public EnableOnlinePredefinedAppointments: boolean;
    public EnableGlobalAvailabilitySearch: boolean;
    public EnablePatientOptimizationForAvailabilitySearchByDefault: boolean;
    public EnableMedicalNoteProtection: boolean;
    public EnableIpsEnrolmentForRamq: boolean;
    public EnableMultifactorAuthenticationByEmail: boolean;
    public EnableNewPatientlessAppointmentBehavior: boolean;
    public EnableDefaultAttachmentsOnConsultationRequests: boolean;
    public EnableBidirectionalCommunication: boolean;
    public BidirectionalCommunicationPatientMessageLimit: number;
    public EnableDSQPrescription: boolean;
    public EnableUserSettingsUiImprovements: boolean;
    public EnableDocumentSourceAuthorField: boolean;
    public EnableDrugInteractionAlertManagement: boolean;
    public EnableMedicationDiscontinueReason: boolean;
    public EnablePrintPatientImmunizationCard: boolean;
    public EnableSendPrescriptionToMylePharmacy: boolean;
    public EnableFaxSendingIndicator: boolean;
    public EnablePharmacyOrders: boolean;
    public EnableSummaryConfiguration: boolean;
    public EnableClinicAidBilling: boolean;
    public PrescriptionReminderDelayInMinutes: number;
    public EnableOntarioHealthInsurancePlanEligibility: boolean;
    public EnablePrescriberDatesAndComplianceFields: boolean;
    public EnablePatientSearchEnrollmentPrioritization: boolean;
    public EnableLazyRenderingFilterSettingsClinicians: boolean;
    public EnableDirectoryOrganizationEdit: boolean;
    public EnableExternalBillingPaymentMode: boolean;
    public EnableMedicationsPrintFilterAndHistory: boolean;
    public EnableRecallList: boolean;
    public EnableMedicationNotes: boolean;
    public EnableUniqueClinicAidPushedLoginEmail: boolean;
    public EnableRoleBasedAccessControl: boolean;
    public EnableUserPatientAutoMergeRequest: boolean;
    public EnableConsultationRequestHistory: boolean;
    public EnableAutofillRecipientInCommunicationTab: boolean;
    public EnablePrescriptionBarcode6Digits: boolean;
    public EnablePatientChartAllowlist: boolean;
    public EnableEnhanceCountriesList: boolean;
    public EnableDoublePatientPrescriptionNotification: boolean;
    public EnableCallCenter: boolean;
    public EnableChronicDiseaseManagement: boolean;
    public EnableChronicDiseaseManagementPrintPdf: boolean;
    public EnablePharmacistCoordinatePrescription: boolean;
    public EnableGdeNoteForm: boolean;
    public GdeNoteFormPilotUsers: string;
    public EnableOptionSignNoteWithoutAppointment: boolean;
    public EnableConseilNumerique: boolean;
    public EnableFaxCoverSheet: boolean;
    public EnableAIScribe: boolean;
    public EnableOacisContextualLaunch: boolean;
    public OacisContextualLaunchPilotUsers: string;
    public EnableDocumentSignoffHistory: boolean;
    public EnableApprovedByColleagueDocumentStatus: boolean;
    public EnableManualEntryOfLabResults: boolean;
    public EnableOntarioCommonDataSetExport: boolean;
    public EnableLabResultProcessingStatus: boolean;
    public EnableAIScribeAlwaysOn: boolean;
    public EnableClinicAidCreateClaimFlow: boolean;
    public EnablePatientInitiatedBidirectionalCommunication: boolean;
    public EnableAIScribeLogs: boolean;
    public EnableResendFaxForAllStatuses: boolean;
    public EnableAlertsAndSpecialNeedsSettings: boolean;
    public EnableCentralizedManualLabsGrid: boolean;
    public EnableLoginPageNewExperience: boolean;
    public EnablePatientSubscription: boolean;
    public EnableAIScribeSignInEndpointV2: boolean;
    public EnableSSOAuthentication: boolean;
    public EnableFixedSignatureRatio: boolean;
    public EnableFormFixedSignatureRatio: boolean;
    public EnableOntarioLaboratoryInformationSystem: boolean;
    public EnableMandatoryMultifactorAuthentication: boolean;
    public EnableAppOnlyMultifactorAuthentication: boolean;
    public EnableMultifactorAuthenticationModule: boolean;
    public EnablePreventiveActivityRequestingStaff: boolean;
    public EnableManualResultsDateSentField: boolean;
    public EnableMarkTestPatient: boolean;
    public EnableOntarioMDConnectivity: boolean;
    public EnablePreventiveActivityItemFreeText: boolean;
    public EnableOntarioDigitalHealthDrugRepository: boolean;
    public EnableOntarioMdHealthReportManager: boolean;
    public EnablePreventiveActivityEnhancements: boolean;
    public EnableOntarioMdHealthReportManagerDocumentVersioning: boolean;

    public constructor(fields?: Partial<ClinicSettings>) {
        Object.assign(this, fields);
    }

    public get IsObstetricalFileEnabled(): boolean {
        return (
            this.EnableOntarioObstetricalFile
            || this.EnableQuebecObstetricalFile
            || this.EnableBritishColumbiaObstetricalFile
        );
    }

    // Feature flag used by the Frontend to enable Voice over IP related features
    public IsCallCenterEnabled = (): boolean => this.EnableRealTimeNotifications && this.EnableCallCenter;
}

export { ClinicSettings };
